// import

import {format} from 'date-fns';
import type { CmsEventListener } from './decapTypes';
import { getQuickId, isStr } from '../libs/rambo';
import { collections } from './collections';

// vars

const collectionKeys = collections.map((c) => c.name);
const collectionDirRx = new RegExp(`(?:${collectionKeys.join('|')})\\/`, 'u');

// export

export function getPreSave(): CmsEventListener {
  return {
    name: 'preSave',
    async handler({entry}) {
      // set id once
      entry = entry = entry.setIn(
        ['data', 'id'], 
        entry.getIn(['data', 'id']) || getQuickId()
      );

      // set createDate once
      entry = entry.setIn(
        ['data', 'createDate'],
        entry.getIn(['data', 'createDate']) ?? format(new Date(), 'yyyy-MM-dd'),
      );

      // update updateDate
      entry = entry.setIn(
        ['data', 'updateDate'],
        format(new Date(), 'yyyy-MM-dd'),
      );

      // proper whitespace
      entry = entry.setIn(
        ['data', 'body'],
        '\n' + entry.getIn(['data', 'body'], '').trim() + '\n',
      );

      // populate slug
      if (!entry.getIn(['data', 'slug'])?.trim()?.length) {
        entry = entry.setIn(
          ['data', 'slug'],
          (entry.getIn(['meta', 'path']) as string | undefined)
            ?.split(collectionDirRx).pop()
            ?.split('.').slice(0, -1).join('/') ??
          entry.getIn(['data', 'title'])
            .toLowerCase()
            .trim()
            .replace(/ +/g, '-'),
        );
      }

      // unset empty fields
      Object.keys(entry.get('data').toJS()).forEach((key) => {
        const val = entry.getIn(['data', key]);
        if (isStr(val) && !val.trim().length) {
          entry = entry.deleteIn(['data', key]);
        }
      });

      // log the entry for debugging
      window.sessionStorage.setItem(
        'preSave:output', 
        JSON.stringify(entry.toJS()),
      );

      return entry.get('data');
    },
  };
}
